import React from "react";
import { procurementApi } from "@/main/api";
import BasePrintPDF from "../../basePrintPDF";
import LayoutOrderPrint from "./layoutOrderPrint";

interface IKOGOrderPrintPDFProps {
  guidProcurement: string;
  showPrices: boolean;
  fileName?: string;
  labelTrigger: string;
  printPrice: boolean;
}
const KOGOrderPrintPDF = ({
  guidProcurement,
  showPrices,
  labelTrigger,
  fileName = "",
  printPrice
}: IKOGOrderPrintPDFProps) => {
  async function loadAsyncData() {
    const { data: { result } } = await procurementApi.orderPrint({
      procurementGuid: guidProcurement,
      printPrice: printPrice
    });
    return result;
  }

  return (
    <BasePrintPDF
      labelTrigger={labelTrigger}
      fileName={fileName}
      onBeforeGetContent={async () => loadAsyncData()}
    >
      <LayoutOrderPrint showPrices={showPrices} />
    </BasePrintPDF>
  )
};

export default KOGOrderPrintPDF;